import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  windowWidth: number;
  windowHeight: number;
}

interface WindowSizesPayload {
  width: number;
  height: number;
}

const initialState: AppState = {
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
};

export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setWindowSizes: (state, action: PayloadAction<WindowSizesPayload>) => {
      state.windowWidth = action.payload.width;
      state.windowHeight = action.payload.height;
    },
  },
});

export const { setWindowSizes } = appSlice.actions;

export default appSlice.reducer;
